import { render, staticRenderFns } from "./TrainingcaseFull.vue?vue&type=template&id=2868e330&scoped=true&"
import script from "./TrainingcaseFull.vue?vue&type=script&lang=js&"
export * from "./TrainingcaseFull.vue?vue&type=script&lang=js&"
import style0 from "./TrainingcaseFull.vue?vue&type=style&index=0&id=2868e330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2868e330",
  null
  
)

export default component.exports